import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { useSettings } from "../../lib/SettingsContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { GraduationCap, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const { settings } = useSettings();
  const location = useLocation();
  const [email, setEmail] = useState("admin@smasypk2biak.sch.id");
  const [password, setPassword] = useState("Admin@123");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace state={{ from: location }} />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Berhasil masuk"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Email atau password salah"); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#0B1D3A] relative overflow-hidden">
      <div className="absolute inset-0 papua-pattern-dark opacity-30" />
      <div className="relative w-full max-w-md mx-6">
        <div className="text-center mb-8">
          <div className={`inline-flex items-center justify-center mb-5 ${settings?.logo_url ? "w-20 h-20 rounded-2xl bg-white p-2 ring-2 ring-amber-400/40" : "w-14 h-14 rounded-2xl bg-amber-500 text-[#0B1D3A]"}`}>
            {settings?.logo_url ? (
              <img src={settings.logo_url} alt="Logo" className="w-full h-full object-contain" />
            ) : (
              <GraduationCap className="w-7 h-7" />
            )}
          </div>
          <h1 className="font-serif text-3xl font-bold text-white">Admin Portal</h1>
          <p className="text-slate-400 text-sm mt-2">SMAS YPK 2 BIAK — CMS Dashboard</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl space-y-5">
          <div><Label htmlFor="l-email">Email</Label><Input id="l-email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11" /></div>
          <div><Label htmlFor="l-pass">Password</Label><Input id="l-pass" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-11" /></div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-11 bg-[#0B1D3A] hover:bg-[#132D58] font-bold rounded-full">{loading ? "Masuk..." : (<>Masuk <LogIn className="ml-2 w-4 h-4" /></>)}</Button>
          <div className="pt-3 border-t border-slate-200 text-xs text-slate-500 text-center">
            Default: <code>admin@smasypk2biak.sch.id</code> / <code>Admin@123</code>
          </div>
        </form>
      </div>
    </div>
  );
}
